<div
  class="go-loader"
  [ngClass]="loaderClasses()"
>
  <div class="go-loader__outer">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150">
      <path d="M2.42,77.42A2.42,2.42,0,0,1,0,75,75,75,0,0,1,143,43.3a2.42,2.42,0,1,1-4.38,2.05A70.16,70.16,0,0,0,4.84,75,2.42,2.42,0,0,1,2.42,77.42Z"/>
    </svg>
  </div>
  <div class="go-loader__middle">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150">
      <path d="M16.94,77.42A2.42,2.42,0,0,1,14.52,75a60.48,60.48,0,0,1,115.3-25.56,2.42,2.42,0,0,1-4.39,2A55.65,55.65,0,0,0,19.35,75,2.41,2.41,0,0,1,16.94,77.42Z"/>
    </svg>
  </div>
  <div class="go-loader__inner">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150">
      <path d="M31.45,77.42A2.42,2.42,0,0,1,29,75a46,46,0,0,1,87.63-19.43,2.42,2.42,0,1,1-4.38,2A41.13,41.13,0,0,0,33.87,75,2.42,2.42,0,0,1,31.45,77.42Z"/>
    </svg>
  </div>
</div>
